var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85389 6.35385H6.51814C5.39951 6.35385 4.84043 6.35385 4.38679 6.55736C3.98691 6.73675 3.64624 7.02566 3.40356 7.3906C3.12824 7.80462 3.03568 8.35616 2.85178 9.45957L1.76769 15.9641L1.76726 15.9665C1.51935 17.454 1.39532 18.1981 1.61072 18.778C1.79984 19.2872 2.16201 19.7139 2.63317 19.9842C3.17006 20.2921 3.92426 20.2921 5.43375 20.2921H17.5659C19.0754 20.2921 19.8308 20.2921 20.3677 19.9842C20.8389 19.7139 21.2002 19.2872 21.3893 18.778C21.6046 18.1983 21.4807 17.4546 21.2329 15.9682L21.232 15.9641L20.1479 9.45957C19.964 8.35616 19.8719 7.80462 19.5966 7.3906C19.3539 7.02566 19.013 6.73675 18.6131 6.55736C18.1595 6.35385 17.6008 6.35385 16.4821 6.35385H16.1461M6.85389 6.35385H16.1461M6.85389 6.35385C6.85389 3.78789 8.93402 1.70776 11.5 1.70776C14.0659 1.70776 16.1461 3.78789 16.1461 6.35385",
    stroke: "#25317A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.2b0f76e76755d339137fc84b4fb7976b.svg";
export { ForwardRef as ReactComponent };